<template>
<!--
<div v-if="kanjiData.terms">
  {{kanjiData.terms._id}}
  </div>-->
  <div v-if="kanjiData.terms || kanjiData.examples">
    <v-card class="mx-auto mb-4" outlined >
      <v-card-title>Kanji presente in: </v-card-title>
      <div class="pl-4 pr-4 pb-4">
        <table class="tb" aria-label="Manuali in cui compare il kanji">
          
          <tr v-if="kanjiData.terms">
            <td class="cfbg"  >{{ kanjiData.terms.textbooklabel }}<br><small>{{kanjiData.terms.credits}}</small></td>
            <td class="darker darken-1">{{ kanjiData.terms.chapter }}</td>
            <td class="blue-gray lighten-5 text-area" v-html="termslist">
            </td>
          </tr>
          <tr v-if="kanjiData.examples">
            <td class="cfbg" >
              {{ kanjiData.examples.textbooklabel }}
              <br><small>{{kanjiData.examples.credits}}</small>
            </td>
            <td class="darker darken-1">{{ kanjiData.examples.chapter}} </td>
            <td  class="blue-gray lighten-5 text-area" v-html="exampleslist">
            </td>

          </tr>
        </table>
      </div>
    </v-card>
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
  data() {
    return {}
  },
  props: ["kanjiData"],
  watch: {},
  mounted() {
    console.log("mmm",this.kanjiData)
  },
  computed:{
    termslist() {
      const a = this.kanjiData.terms.terms.map((e) => {
        return e.original;
      }).join(", ");
      return a;

    },
    exampleslist() {
      return this.kanjiData.examples.examples.map((e) => {
        return e.original;
      }).join("<br>");
    }
  },
  methods: {},
};
</script>

<style scoped>
.tb td {
  vertical-align:top;
  padding:12px;
}
.tb td.blue {
  color:white;
}
.deep-orange.darken-1 {
  color:white;
}
.text-area {
  border-radius:8px;
  border:1px solid #dddddd;
}
td small {
  font-size:10px;
}
</style>
